<template>
  <div class="sign-up">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../../assets/images/global/logo.svg">
            <router-link to="/login" class="btn bg-three active">Log In</router-link>
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">
          <div class="left-panel-centre">
            <h1>Exchange ideas, <span style="color: #1AAD8F">drive change for Africa</span></h1>
            <p>Connect, match, chat and build networks instantly within a global community passionate about Africa. Share your big ideas for African development, exchange skills, expertise and let's make change happen together.</p>

            <form @submit.prevent="register">
              <input :class="{ error: hasError }" type="email" v-model.trim="email" placeholder="someone@example.com" required />
              <input class="btn btn-big bg-four active" type="submit" value="Create Account">
              <p class="feedback" v-show="hasError">{{ message }}</p>
            </form>

          </div>
        </div>
        <ul class="bottom">
          <li><a target="_blank" href="http://planetearthinstitute.org.uk" class="link blue">Visit PEI Website</a></li>
          <li><router-link to="terms" class="link navy">Terms &amp; Conditions</router-link></li>
        </ul>
      </div>
    </section>
    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { auth } from '@/firebase'

export default {
  name: 'Register',
  data () {
    return {
      email: '',
      message: '',
      hasError: false
    }
  },
  methods: {
    register () {
      console.log(this.email)
      if (this.email) {
        document.getElementsByTagName('input').disabled = true
        let parent = this
        let newPassword = Math.random().toString(36).slice(-8) // Random password
        auth.createUserWithEmailAndPassword(this.email, newPassword)
          .then(function (user) {
            // Go to next registration step
            console.log(user.uid)
            parent.$parent.currentStep++
          })
          .catch(function (err) {
            // Handle errors
            document.getElementsByTagName('input').disabled = false
            console.log(err.code)
            parent.message = err.message
            parent.hasError = true
          })
      } else {
        console.error('no email given')
      }
    }
  },
  beforeCreate () {
    auth.signOut().then(function () {
      console.log('Logged out')
    }, function (error) {
      // An error happened.
      console.error(error)
    })
  },
  watch: {
    email: function (val) {
      this.hasError = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-1.vue?3e55bd34